"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetModel = resetModel;
exports.createModel = createModel;
exports.createDataFromModel = createDataFromModel;

var _lodash = require("lodash");

function resetModel(model, baseModel) {
  (0, _lodash.forEach)(model, function (def, key) {
    var val = null;

    if (def.defaultValue) {
      val = def.defaultValue;
    } else if (def.type) {
      var Type = def.type;
      val = new Type();
    }

    baseModel[key] = val;
  });
  return baseModel;
}

function createModel(model) {
  return resetModel(model, {});
}

function createDataFromModel(model, data) {
  var returnData = {};
  (0, _lodash.forEach)(data, function (val, key) {
    if (model.hasOwnProperty(key)) {
      returnData[model[key].field] = val;
    }
  });
  return returnData;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/utils/model-factory.js
// module id = 219
// module chunks = 0